export function isInvoiceNumberValid(invoiceNumber) {
    if (invoiceNumber?.length <= 0) {
        return true
    }

    const invoiceNumberRegex = /^[0-9a-zA-Z/\-\\.#_()|&]{1,50}$/;
    return invoiceNumberRegex.test(invoiceNumber);
}
